import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, object, string } from "prop-types";

import Anchor from "../Anchor";
import Image from "../Image";

import { bannerHeight, getCollectionName, getSlug } from "../../utils/utils";

import "./collection-banner.m.css";

const CollectionBanner = ({ collection = {}, className = "", isDesktopBanner = "", sections = [], domainSlug }) => {
  const coverImageS3key = collection.metadata?.["cover-image"]?.["cover-image-s3-key"];

  const { navigate_to: navigateTo, navigate_to_title: navigateToTitle } = collection["associated-metadata"] || {};

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);

  if (!coverImageS3key) return null;

  const [isMobile, setMobile] = useState();

  let { desktop_banner: desktopBanner = "" } = collection["associated-metadata"] || {};

  desktopBanner = desktopBanner.trim();

  useEffect(() => {
    setMobile(window.deviceWidth < 876);
  }, []);

  const paddingTops = bannerHeight(collection);

  return (
    <div
      style={paddingTops}
      styleName={`base ${!isDesktopBanner && !desktopBanner ? "only-mobile" : ""}`}
      className={`${className} collection-banner`}
    >
      <Anchor
        aria-label={collectionName}
        href={collectionSlug}
        styleName="link"
        className="banner-link"
        style={{ backgroundImage: "url(/media-placeholder.svg)" }}
      >
        {isDesktopBanner ? (
          isMobile === undefined ? null : isMobile ? (
            <Image slug={coverImageS3key} alt={collectionName} styleName="image" width="100%" />
          ) : (
            <img src={desktopBanner} styleName="image" width="100%" alt={collectionName} />
          )
        ) : (
          <Image slug={coverImageS3key} alt={collectionName} styleName="image" width="100%" />
        )}
      </Anchor>
    </div>
  );
};

CollectionBanner.propTypes = {
  collection: object,
  className: string,
  isDesktopBanner: bool,
  sections: arrayOf(object),
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: state.qt.config.sections,
  domainSlug: state.qt.config.domainSlug,
});

export default connect(mapStateToProps)(CollectionBanner);
